export default __webpack_public_path__ + "static/media/tracy1.a10d30b5.jpeg";